import type { AttachmentCapabilities } from "./attachments/types";
import { DISABLED_CAPABILITIES } from "./attachments/types";

/** Shape returned by GET /api/copilotkit/info?app=school. Consumed by
 *  TeacherWorkbenchPage + ChatLandingPage for the pre-flight capability
 *  + agent-list query. Kept in `chat/` because attachments are
 *  conceptually chat-side and AttachmentCapabilities already lives here. */
export interface AgentsInfo {
  agentIds: string[];
  attachments: AttachmentCapabilities;
}

export async function fetchAgentsInfo(
  authHeader: Record<string, string>,
): Promise<AgentsInfo> {
  const response = await fetch("/api/copilotkit/info?app=school", {
    headers: authHeader,
  });
  if (!response.ok) {
    return { agentIds: [], attachments: DISABLED_CAPABILITIES };
  }
  const body = (await response.json()) as {
    agents?: Array<{ id: string }>;
    capabilities?: { attachments?: AttachmentCapabilities };
  };
  return {
    agentIds: (body.agents ?? []).map((agent) => agent.id),
    attachments: body.capabilities?.attachments ?? DISABLED_CAPABILITIES,
  };
}
